package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.JoystickW500Rounded: ImageVector
    get() {
        if (_joystickW500Rounded != null) {
            return _joystickW500Rounded!!
        }
        _joystickW500Rounded = Builder(name = "JoystickW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(282.04f, 520.96f)
                lineTo(480.0f, 635.22f)
                lineToRelative(197.96f, -114.26f)
                lineToRelative(-152.46f, -87.92f)
                verticalLineToRelative(121.22f)
                horizontalLineToRelative(-91.0f)
                verticalLineToRelative(-121.22f)
                lineToRelative(-152.46f, 87.92f)
                close()
                moveTo(434.5f, 331.0f)
                verticalLineToRelative(-17.24f)
                quadToRelative(-44.24f, -14.43f, -72.12f, -51.77f)
                quadToRelative(-27.88f, -37.34f, -27.88f, -86.06f)
                quadToRelative(0.0f, -60.39f, 42.55f, -102.94f)
                quadToRelative(42.56f, -42.56f, 102.95f, -42.56f)
                reflectiveQuadToRelative(102.95f, 42.56f)
                quadToRelative(42.55f, 42.55f, 42.55f, 102.94f)
                quadToRelative(0.0f, 48.72f, -27.88f, 86.06f)
                reflectiveQuadToRelative(-72.12f, 51.77f)
                lineTo(525.5f, 331.0f)
                lineToRelative(277.13f, 159.33f)
                quadToRelative(21.39f, 12.43f, 33.45f, 33.56f)
                quadToRelative(12.05f, 21.13f, 12.05f, 46.0f)
                verticalLineToRelative(72.65f)
                quadToRelative(0.0f, 24.87f, -12.05f, 46.0f)
                quadToRelative(-12.06f, 21.13f, -33.45f, 33.57f)
                lineTo(525.5f, 881.44f)
                quadTo(504.11f, 893.87f, 480.0f, 893.87f)
                reflectiveQuadToRelative(-45.5f, -12.43f)
                lineTo(157.37f, 722.11f)
                quadToRelative(-21.39f, -12.44f, -33.45f, -33.57f)
                quadToRelative(-12.05f, -21.13f, -12.05f, -46.0f)
                verticalLineToRelative(-72.65f)
                quadToRelative(0.0f, -24.87f, 12.05f, -46.0f)
                quadToRelative(12.06f, -21.13f, 33.45f, -33.56f)
                lineTo(434.5f, 331.0f)
                close()
                moveTo(434.5f, 711.15f)
                lineTo(200.48f, 576.5f)
                verticalLineToRelative(67.48f)
                lineTo(480.0f, 805.74f)
                lineToRelative(279.52f, -161.76f)
                verticalLineToRelative(-67.48f)
                lineTo(525.5f, 711.15f)
                quadToRelative(-21.39f, 12.44f, -45.5f, 12.44f)
                reflectiveQuadToRelative(-45.5f, -12.44f)
                close()
                moveTo(518.55f, 214.49f)
                quadToRelative(15.95f, -15.95f, 15.95f, -38.56f)
                quadToRelative(0.0f, -22.6f, -15.95f, -38.55f)
                quadToRelative(-15.94f, -15.95f, -38.55f, -15.95f)
                reflectiveQuadToRelative(-38.55f, 15.95f)
                quadToRelative(-15.95f, 15.95f, -15.95f, 38.55f)
                quadToRelative(0.0f, 22.61f, 15.95f, 38.56f)
                quadToRelative(15.94f, 15.94f, 38.55f, 15.94f)
                reflectiveQuadToRelative(38.55f, -15.94f)
                close()
                moveTo(480.0f, 805.74f)
                close()
            }
        }
        .build()
        return _joystickW500Rounded!!
    }

private var _joystickW500Rounded: ImageVector? = null
